import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";

import rootSaga from "@/redux/rootSaga";

import srpSlice from "@/redux/SRP/srpSlice.js";
import agentSlice from "../features/agent/agentSlice";
import stageSlice from "../bidFeature/bidwizardSlice";
import filterSlice from "../features/filter/filterSlice";
import propertiesSlice from "../redux/SRP/propertiesSlice";
import srpFilterSlice from "@/redux/SRP/srpFilterSlice.js";
import srpSearchSlice from "@/redux/SRP/srpSearchSlice.js";
import savedSearchSlice from "@/redux/SRP/savedSearchSlice";
import recentSearchSlice from "@/redux/SRP/recentSearchSlice";
import propertyDetailSlice from "../bidFeature/propertyDetailSlice";

import pdpReducer from "@/redux/PDP/pdpSlice";
import cmsReducer from "../redux/cms/cmsSlice";
import bidReducer from "../bidFeature/bidSlice";
import userReducer from "../redux/user/userSlice";
import loginReducer from "../redux/login/loginSlice";
import { otpModalReducer } from "@/redux/otpModal/otpModalSlice";
import savedPreferenceReducer from "../redux/savedpreference/savedPreferenceSlice";
import commonReducer from "../redux/common/commonSlice";
import authReducer from "../redux/auth/authSlice";
import userSliceBid from "../bidFeature/userDetails";
const sagaMiddleware = createSagaMiddleware();

// Define persist configuration and whitelisting
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cms", "auth", "common", "pdp"],
};

// Combine reducers
const rootReducer = combineReducers({
  pdp: pdpReducer,
  properties: propertiesSlice,
  filter: filterSlice,
  agent: agentSlice,
  srp: srpSlice,
  auth: authReducer,
  srpFilter: srpFilterSlice,
  srpSearch: srpSearchSlice,
  bidDeposit: bidReducer,
  user: userReducer,
  propertyDetail: propertyDetailSlice,
  recentSearch: recentSearchSlice,
  savedSearch: savedSearchSlice,
  savedPreference: savedPreferenceReducer,
  bidwizardStage: stageSlice,
  login: loginReducer,
  otpModal: otpModalReducer,
  cms: cmsReducer,
  userSliceDetails: userSliceBid,
  common: commonReducer,
});

// Create a persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false, // disable serializable check for redux-persist
    }).concat(sagaMiddleware),
});

// Create persistor
export const persistor = persistStore(store);

// Run the root saga
sagaMiddleware.run(rootSaga);
